import { TextField } from "@material-ui/core";
import React from "react";
import {
  useConvertFromPenceFactory,
  useConvertFromPoundsFactory,
} from "../currencies";

export function parseNumber(numberStr: string): number {
  const floatValue = Number.parseFloat(numberStr);
  if (!Number.isNaN(floatValue)) {
    return floatValue;
  }
  const intValue = Number.parseInt(numberStr, 10);
  if (!Number.isNaN(floatValue)) {
    return intValue;
  }
  throw new Error("Could not parse number string.");
}

type TextFieldProps = React.ComponentProps<typeof TextField>;

export const ZeroOrGreaterMonetaryAmountInPoundsField: FC<
  {
    valueInPence: number;
    onChangeInPence: (valueInPence: number) => void;
  } & Omit<TextFieldProps, "value" | "onChange">
> = ({ valueInPence, onChangeInPence, ...delegateProps }) => {
  const penceToPounds = useConvertFromPenceFactory();
  const poundsToPence = useConvertFromPoundsFactory();

  return (
    <TextField
      type="number"
      variant="outlined"
      value={penceToPounds(valueInPence)?.toString()}
      onChange={(e) => {
        let numberValue = 0;
        try {
          numberValue = parseNumber(e.target.value);
        } catch (_) {
          console.info(`Number not parseable, defaulting to ${numberValue}.`);
        }
        const value = Math.max(0, numberValue);
        const pence = Number(poundsToPence(value));
        onChangeInPence(pence);
      }}
      {...delegateProps}
    />
  );
};

export default ZeroOrGreaterMonetaryAmountInPoundsField;
